
export default {
    fetch({ error }) {
        error({ statusCode: 404, message: 'Page not found' });
    }
};
